import styled from "styled-components";
import Box from "../../containers/Box";

export const Container = styled(Box)`
  height: 30px;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.colorTokens.background.layer};
`;
